/**
 * Full vehicle row as exposed by `GET /api/vehicles` —
 * matches `vehicleResponseSchema` from
 * `apps/api/src/modules/vehicles/vehicles.schema.ts`.
 *
 * `numeric(10,2)` columns round-trip as `string`. The display
 * helpers (`formatMoney`, etc.) coerce on read.
 */
export interface VehicleRow {
  id: string
  registration: string
  brand: string | null
  model: string | null
  type: string | null
  vin: string | null
  currentMileage: number | null
  initialMileage: number
  fuelPricePerLiter: string | null
  rentalRate: string | null
  purchaseValue: string | null
  depreciationMonths: number | null
  residualValue: string | null
  commissionDate: string | null
  active: boolean
  createdAt: string
  updatedAt: string
}

/** Common vehicle types — used for the filter `<select>`. */
export const VEHICLE_TYPES = [
  'benne',
  'toupie',
  'grue',
  'camion',
  'tractopelle',
  'utilitaire',
] as const

export type VehicleType = (typeof VEHICLE_TYPES)[number]
